module.exports = __webpack_public_path__ + "2668bda0c66b4806cc943ce38259d530.svg";